<template>
  <div>
    <canvas-annotation v-if="thumbnailAnnotation == thumbnailAnnotationType.cirrusReferenceMacular"
      :canvasSize="imgSize"
      :annotation="fourSquareGrid" />
    <canvas-annotation v-else-if="thumbnailAnnotation == thumbnailAnnotationType.cirrusReferenceRaster || thumbnailAnnotation == thumbnailAnnotationType.spectralisVolume 
    || thumbnailAnnotation == thumbnailAnnotationType.spectralisSection"
      :canvasSize="imgSize"
      :annotation="linesIndicator" />
    <canvas-annotation v-else-if="thumbnailAnnotation == thumbnailAnnotationType.cirrusReferenceOpticDisc"
      :canvasSize="imgSize"
      :annotation="opticDiscGrid" />
    <canvas-annotation v-else-if="thumbnailAnnotation == thumbnailAnnotationType.spectralisCircle"
      :canvasSize="imgSize"
      :annotation="circleGrid" />
    <canvas-annotation v-else-if="thumbnailAnnotation == thumbnailAnnotationType.spectralisRadial"
      :canvasSize="imgSize"
      :annotation="radialGrid" />
    <canvas-annotation v-else-if="thumbnailAnnotation == thumbnailAnnotationType.spectralisRadialSCN"
      :canvasSize="imgSize"
      :annotation="spectralisRadialSCN" />
    <canvas-annotation v-else-if="thumbnailAnnotation == thumbnailAnnotationType.spectralisRadialCircle"
      :canvasSize="imgSize"
      :annotation="radialCircleGrid" />
    <v-menu v-if="showDropdown" offset-y :nudge-width="100">
      <template v-slot:activator="{ on }">
        <image-button 
          :class="dropdownClass" 
          v-on="on" 
          icon 
          :image="coloredAssetUrls.dropdown" />
      </template>
      <v-list>
        <v-list-item @click="$emit('multiview-launch', thumbnailDropdown.currentPrevious)">
          <v-list-item-title>Current + Previous</v-list-item-title>
        </v-list-item>
        <v-list-item @click="$emit('multiview-launch', thumbnailDropdown.currentBaseline)">
          <v-list-item-title>Current + Baseline</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>
<script>
import canvasAnnotation from "../../canvas/components/CanvasAnnotation";
import FourSquareGrid from "../../canvas/annotations/fourSquareGrid";
import OpticDiscGrid from "../../canvas/annotations/opticDiscGrid";
import LinesIndicator from "../../canvas/annotations/linesIndicator";
import CircleGrid from "../../canvas/annotations/circleGrid";
import RadialGrid from "../../canvas/annotations/radialGrid";
import RadialCircleGrid from "../../canvas/annotations/radialCircleGrid";
import SpectralisRadialSCN from "../../canvas/annotations/spectralisRadialSCN"
import imageButton from "../controls/ImageButton";
import { THUMBNAIL_DROPDOWN, THUMBNAIL_ANNOTATION_TYPE } from "../../config/config";

export default {
  name: "thumbnailMisc",
  components: { canvasAnnotation, imageButton },
   props: {
    imgSize: Object,
    thumbnailAnnotation: null,
    showDropdown: Boolean,
    proofsheet: Boolean,
  },
  data() {
    return {
      fourSquareGrid: new FourSquareGrid(),
      opticDiscGrid: new OpticDiscGrid(),
      linesIndicator: new LinesIndicator(),
      circleGrid: new CircleGrid(),
      radialGrid: new RadialGrid(),
      radialCircleGrid: new RadialCircleGrid(),
      spectralisRadialSCN: new SpectralisRadialSCN(),
      thumbnailDropdown: THUMBNAIL_DROPDOWN,
      thumbnailAnnotationType : THUMBNAIL_ANNOTATION_TYPE
    };
  },
  computed:{
    dropdownClass(){
      return this.proofsheet ? "cirrus-reference-dropdown-proofsheet" : "cirrus-reference-dropdown";
    }
  },
  mounted(){
    if(this.thumbnailAnnotation == this.thumbnailAnnotationType.spectralisVolume){
      this.linesIndicator.updateNumberOfLines(15);
    }
    else if (this.thumbnailAnnotation == this.thumbnailAnnotationType.spectralisSection){
        this.linesIndicator.updateNumberOfLines(1);
    }
  }
}
</script>
<style lang="scss" scoped>
  .cirrus-reference-dropdown{
    position: absolute;
    top: 98px;
    left: 7px;
  }
  .cirrus-reference-dropdown-proofsheet{
     position: absolute;
    bottom: 0px;
    left: 5px;
  }
</style>